// extracted by mini-css-extract-plugin
module.exports = {"slider":"styles-module--slider--2bvRN"};